import React from "react";

// Composant simplifié pour éviter les problèmes de rechargement infini
export const UpdatePrompt = () => {
  // Ne rien rendre - composant simplifié
  return null;
};
